(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-clinical-timeline"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('th-clinical-timeline'))customElements.define('th-clinical-timeline',class extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal},track=this.querySelector('.cwt-track'),tabs=[...this.querySelectorAll('[data-step]')],cards=[...this.querySelectorAll('[data-step-card]')],prev=this.querySelector('[data-step-prev]'),next=this.querySelector('[data-step-next]');let index=0;
const sync=i=>{index=Math.max(0,Math.min(tabs.length-1,i));tabs.forEach((t,n)=>{t.classList.toggle('on',n===index);t.classList.toggle('done',n<index);t.setAttribute('aria-pressed',String(n===index))});cards.forEach((c,n)=>c.hidden=n!==index);this.querySelector('.cwt-fill').style.width=(index/(tabs.length-1)*75)+'%';prev.disabled=index===0;next.disabled=index===tabs.length-1};
const go=i=>{sync(i);track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};tabs.forEach((t,i)=>t.addEventListener('click',()=>go(i),opts));prev.addEventListener('click',()=>go(index-1),opts);next.addEventListener('click',()=>go(index+1),opts);track.addEventListener('scroll',()=>sync(Math.round(track.scrollLeft/track.clientWidth)),{...opts,passive:true});this.resize=new ResizeObserver(()=>track.scrollTo({left:index*track.clientWidth,behavior:'instant'}));this.resize.observe(track);sync(0)}
disconnectedCallback(){this.abort?.abort();this.resize?.disconnect()}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-expert-perspectives"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tb-expert-cards')){
customElements.define('tb-expert-cards',class extends HTMLElement{
connectedCallback(){
if(this.controller)return;
this.controller=new AbortController();
const options={signal:this.controller.signal};
const track=this.querySelector('.tb-experts__track');
const cards=[...this.querySelectorAll('.tb-experts__card')];
const buttons=[...this.querySelectorAll('[data-direction]')];
const count=this.querySelector('.tb-experts__count');
const update=()=>{
const max=track.scrollWidth-track.clientWidth;
let index=0;
cards.forEach((card,i)=>{if(Math.abs(card.offsetLeft-cards[0].offsetLeft-track.scrollLeft)<Math.abs(cards[index].offsetLeft-cards[0].offsetLeft-track.scrollLeft))index=i;});
if(max>0&&track.scrollLeft>=max-2)index=cards.length-1;
if(count)count.textContent=(index+1)+' / '+cards.length;
buttons.forEach(button=>button.disabled=Number(button.dataset.direction)<0?track.scrollLeft<=2:track.scrollLeft>=max-2);
};
buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*(cards[0].getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),options));
track.addEventListener('scroll',update,options);
this.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.tb-experts__card');if(card)track.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:'instant'});},options);
this.observer=new ResizeObserver(update);this.observer.observe(track);update();
}
disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-five-reasons"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){root.querySelectorAll('.fiver-countdown').forEach(el=>{if(el.dataset.started)return;const end=Date.parse(el.dataset.deadline);if(!Number.isFinite(end))return;el.dataset.started='true';el.hidden=false;const update=()=>{const seconds=Math.max(0,Math.floor((end-Date.now())/1000));el.querySelector('[data-clock]').textContent=seconds?`${Math.floor(seconds/86400)}d ${String(Math.floor(seconds/3600)%24).padStart(2,'0')}h ${String(Math.floor(seconds/60)%60).padStart(2,'0')}m ${String(seconds%60).padStart(2,'0')}s`:'Offer ended';if(!seconds){const link=el.closest('.fiver-offer').querySelector('.fiver-checkout');if(link){link.removeAttribute('href');link.setAttribute('aria-disabled','true');link.textContent='Offer ended'}clearInterval(timer)}};const timer=setInterval(update,1000);update()})}init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

if(!customElements.get('fiver-loop'))customElements.define('fiver-loop',class extends HTMLElement{
connectedCallback(){if(this.observer)return;const video=this.querySelector('video'),button=this.querySelector('button');this.abort=new AbortController();const opts={signal:this.abort.signal};let manualPause=false;const reduced=matchMedia('(prefers-reduced-motion: reduce)');const load=()=>{if(!video.getAttribute('src')){video.src=video.dataset.src;video.load()}};const play=()=>{load();video.muted=true;video.play().catch(()=>{button.textContent='Play';button.setAttribute('aria-label','Play demonstration')})};video.addEventListener('play',()=>{button.textContent='Pause';button.setAttribute('aria-label','Pause demonstration')},opts);video.addEventListener('pause',()=>{button.textContent='Play';button.setAttribute('aria-label','Play demonstration')},opts);button.addEventListener('click',()=>{if(video.paused){manualPause=false;play()}else{manualPause=true;video.pause()}},opts);this.observer=new IntersectionObserver(entries=>{for(const entry of entries){if(entry.isIntersecting){if(!reduced.matches&&!manualPause&&!document.hidden)play()}else video.pause()}},{threshold:.15});this.observer.observe(this);document.addEventListener('visibilitychange',()=>{if(document.hidden)video.pause();else{const r=this.getBoundingClientRect();if(r.top<innerHeight&&r.bottom>0&&!manualPause&&!reduced.matches)play()}},opts)}
disconnectedCallback(){this.observer?.disconnect();this.observer=null;this.abort?.abort();this.querySelector('video')?.pause()}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-gift-sticky"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-gift-sticky')) {
    customElements.define('tb-gift-sticky', class extends HTMLElement {
      connectedCallback() {
        this.queueUpdate = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        };
        window.addEventListener('scroll', this.queueUpdate, { passive: true });
        window.addEventListener('resize', this.queueUpdate, { passive: true });
        this.resizeObserver = new ResizeObserver(this.queueUpdate);
        this.resizeObserver.observe(document.body);
        this.dialogObserver = new MutationObserver(this.queueUpdate);
        this.dialogObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'aria-modal', 'aria-hidden', 'style'] });
        this.queueUpdate();
      }
      update() {
        const maxScroll = Math.max(0, document.documentElement.scrollHeight - innerHeight);
        const progress = maxScroll ? Math.max(0, scrollY) / maxScroll * 100 : 0;
        const threshold = Number(this.dataset.scrollThreshold || 20);
        const offer = document.getElementById(this.dataset.target);
        const bounds = offer?.getBoundingClientRect();
        const offerVisible = this.dataset.hideOffer === 'true' && bounds && bounds.top < innerHeight && bounds.bottom > 0;
        const dialogOpen = [...document.querySelectorAll('dialog[open],cart-drawer.active,.slidecarthq.open[role="dialog"],[aria-modal="true"]')].some(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
        const forcePreview = this.dataset.editor === 'true' && this.dataset.preview === 'true';
        this.hidden = !forcePreview && (progress < threshold || offerVisible || dialogOpen);
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.queueUpdate);
        window.removeEventListener('resize', this.queueUpdate);
        this.resizeObserver?.disconnect();
        this.dialogObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-gift-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-gift-testimonials')) {
    customElements.define('tb-gift-testimonials', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.tb-tc__track');
        this.cards = Array.from(this.querySelectorAll('.tb-tc__card'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.controls = this.querySelector('[data-controls]');
        this.play = this.querySelector('[data-play]');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = this.reduced || this.dataset.editor === 'true';
        this.index = 0;
        this.hovering = false;
        this.onScreen = false;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        }, {passive:true, signal});
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.manual(this.index - 1), {signal});
        this.querySelector('[data-next]')?.addEventListener('click', () => this.manual(this.index + 1), {signal});
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.manual(i), {signal}));
        this.play?.addEventListener('click', () => { this.paused = !this.paused; this.syncPlay(); this.schedule(); }, {signal});
        this.track.addEventListener('pointerdown', () => this.pause(), {signal});
        this.track.addEventListener('wheel', () => this.pause(), {passive:true, signal});
        this.track.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          this.manual(event.key === 'Home' ? 0 : event.key === 'End' ? this.last : this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, {signal});
        this.addEventListener('mouseenter', () => { this.hovering=true; clearTimeout(this.timer); }, {signal});
        this.addEventListener('mouseleave', () => { this.hovering=false; this.schedule(); }, {signal});
        this.addEventListener('focusin', () => clearTimeout(this.timer), {signal});
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), {signal});
        document.addEventListener('visibilitychange', () => this.schedule(), {signal});
        this.addEventListener('shopify:block:select', event => {
          const i=this.cards.findIndex(card => card===event.target || card.contains(event.target));
          if (i>=0) this.manual(Math.min(i,this.last));
        }, {signal});
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this.track);
        this.observer = new IntersectionObserver(entries => { this.onScreen=entries[0].isIntersecting; this.schedule(); }, {threshold:0.25});
        this.observer.observe(this);
        this.measure();
        this.syncPlay();
      }
      measure() {
        this.step=this.cards.length>1 ? this.cards[1].offsetLeft-this.cards[0].offsetLeft : this.track.clientWidth;
        this.max=Math.max(0,this.track.scrollWidth-this.track.clientWidth);
        this.last=this.step>0 ? Math.ceil(Math.max(0,this.max-2)/this.step) : 0;
        if(this.controls) this.controls.hidden=this.last===0;
        this.dots.forEach((dot,i) => dot.hidden=i>this.last);
        this.update();
        this.schedule();
      }
      update() {
        this.index=this.step>0 ? Math.min(this.last,Math.round(this.track.scrollLeft/this.step)) : 0;
        this.dots.forEach((dot,i) => { if(i===this.index) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      }
      move(index,announce=false) {
        const target=index<0 ? this.last : index>this.last ? 0 : index;
        this.track.scrollTo({left:Math.min(target*this.step,this.max),behavior:this.reduced?'auto':'smooth'});
        if(announce) { const status=this.querySelector('[data-status]'); if(status) status.textContent='Showing testimonial '+(target+1)+' of '+this.cards.length; }
      }
      manual(index) { this.pause(); this.move(index,true); }
      pause() { this.paused=true; clearTimeout(this.timer); this.syncPlay(); }
      syncPlay() {
        if(!this.play) return;
        this.play.setAttribute('aria-label',this.paused?'Play testimonials':'Pause testimonials');
        this.play.querySelector('[data-play-label]').textContent=this.paused?'Play':'Pause';
      }
      schedule() {
        clearTimeout(this.timer);
        if(this.dataset.autoplay!=='true'||this.paused||this.hovering||!this.onScreen||document.hidden||this.contains(document.activeElement)||!this.last) return;
        this.timer=setTimeout(() => { this.move(this.index+1); this.schedule(); },Number(this.dataset.interval)||7000);
      }
      disconnectedCallback() {
        this.abort?.abort(); this.abort=null;
        this.resize?.disconnect(); this.observer?.disconnect();
        clearTimeout(this.timer); cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tbhl-transformation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('th-revival-timeline'))customElements.define('th-revival-timeline',class extends HTMLElement{
connectedCallback(){this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal},track=this.querySelector('.cwt-track'),tabs=[...this.querySelectorAll('[data-step]')],cards=[...this.querySelectorAll('[data-step-card]')],prev=this.querySelector('[data-step-prev]'),next=this.querySelector('[data-step-next]');let index=0;
const sync=i=>{index=Math.max(0,Math.min(tabs.length-1,i));tabs.forEach((t,n)=>{t.classList.toggle('on',n===index);t.classList.toggle('done',n<index);t.setAttribute('aria-pressed',String(n===index))});cards.forEach((c,n)=>c.hidden=n!==index);this.querySelector('.cwt-fill').style.width=(index/(tabs.length-1)*75)+'%';prev.disabled=index===0;next.disabled=index===tabs.length-1};
const go=i=>{sync(i);track.scrollTo({left:index*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})};tabs.forEach((t,i)=>t.addEventListener('click',()=>go(i),opts));prev.addEventListener('click',()=>go(index-1),opts);next.addEventListener('click',()=>go(index+1),opts);track.addEventListener('scroll',()=>sync(Math.round(track.scrollLeft/track.clientWidth)),{...opts,passive:true});this.resize=new ResizeObserver(()=>track.scrollTo({left:index*track.clientWidth,behavior:'instant'}));this.resize.observe(track);sync(0)}
disconnectedCallback(){this.abort?.abort();this.resize?.disconnect()}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-promotion-countdown"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('th-promo-countdown')){
  customElements.define('th-promo-countdown',class extends HTMLElement{
    connectedCallback(){
      if(this.hasAttribute('data-disabled')||this.interval)return;
      const timer=this.querySelector('.th-promo__timer');
      if(!timer)return;
      const daily=this.hasAttribute("data-daily-midnight");
      let end=daily?this.nextMidnight(Date.now()):this.deadlineTimestamp();
      if(!Number.isFinite(end)){
        const hint=this.querySelector('[data-deadline-hint]');
        if(hint)hint.hidden=false;
        return;
      }
      const digits=Object.fromEntries(['days','hours','minutes','seconds'].map(key=>[key,this.querySelector('[data-time="'+key+'"]')]));
      const update=()=>{
        const now=Date.now();
        if(daily&&now>=end)end=this.nextMidnight(now);
        const remaining=Math.max(0,Math.ceil((end-now)/1000));
        if(remaining===0){
          timer.hidden=true;
          if(this.dataset.expiry==='hide'&&!this.hasAttribute('data-editor'))this.hidden=true;
          else{
            this.querySelector('.th-promo__message').hidden=true;
            const link=this.querySelector('.th-promo__link');if(link)link.hidden=true;
            this.querySelector('.th-promo__expired').hidden=false;
          }
          clearInterval(this.interval);this.interval=null;return false;
        }
        const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
        Object.entries(values).forEach(([key,value])=>{const text=String(value).padStart(2,'0');if(digits[key].textContent!==text)digits[key].textContent=text;});
        timer.hidden=false;return true;
      };
      if(update())this.interval=setInterval(update,1000);
    }
    nextMidnight(now){
      // Find the first second of the next calendar date in the configured zone.
      const fmt=new Intl.DateTimeFormat('en-US',{timeZone:this.dataset.timezone,year:'numeric',month:'numeric',day:'numeric'});
      let low=Math.floor(now/1000),high=low+26*3600;
      const today=fmt.format(low*1000);
      while(high-low>1){
        const mid=Math.floor((low+high)/2);
        if(fmt.format(mid*1000)===today)low=mid;else high=mid;
      }
      return high*1000;
    }
    deadlineTimestamp(){
      const {year,month,day,hour,minute,period,timezone}=this.dataset;
      if(![year,month,day,hour,minute].every(value=>/^\d+$/.test(value||'')))return NaN;
      const y=Number(year),m=Number(month),d=Number(day),h=Number(hour),min=Number(minute);
      if(y<2026||m<1||m>12||d<1||d>31||h<1||h>12||min<0||min>59||!['AM','PM'].includes(period))return NaN;
      const hour24=h%12+(period==='PM'?12:0);
      const wall=Date.UTC(y,m-1,d,hour24,min);
      const date=new Date(wall);
      if(date.getUTCFullYear()!==y||date.getUTCMonth()!==m-1||date.getUTCDate()!==d)return NaN;
      try{
        const formatter=new Intl.DateTimeFormat('en-US-u-ca-gregory-nu-latn',{timeZone:timezone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
        const wallAt=timestamp=>{
          const parts=Object.fromEntries(formatter.formatToParts(new Date(timestamp)).map(part=>[part.type,part.value]));
          return Date.UTC(Number(parts.year),Number(parts.month)-1,Number(parts.day),Number(parts.hour),Number(parts.minute),Number(parts.second));
        };
        const offsets=new Set([-86400000,0,86400000].map(delta=>wallAt(wall+delta)-(wall+delta)));
        const matches=Array.from(offsets,offset=>wall-offset).filter(timestamp=>wallAt(timestamp)===wall);
        return matches.length?Math.min(...matches):NaN;
      }catch{return NaN;}
    }
    disconnectedCallback(){clearInterval(this.interval);this.interval=null;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
